import {call, all, select, put} from "redux-saga/effects"

import api from "../../services/ApiService"
import {LearningCreators as Creators} from "./redux"
import {LangSwitchCreators as LangCreators} from "../../components/LangSwitch/redux"
import {AppCreators} from "../App/redux"
import {checkEnv, i18n, readableErrors} from "../../utils"

export default function* learning(_dispatch, _action) {
  let state = yield select()
  const lang = state.app.lang

  // check if learning is disabled
  if (checkEnv("DISABLE_LEARNING")) {
    return
  }

  yield put(Creators.request())

  try {
    const [
      topicResponse,
      contentResponse,
      sidebarResponse,
      userDataResponse,
      tagsResponse
    ] = yield all([
      call(api.getLearningThemes, lang),
      call(api.getPageContentBySlug, "Lernen", lang),
      call(api.getLearningSidebar, lang),
      call(api.getUserProfile),
      call(api.getLearningTags, lang)
    ])

    yield put(
      Creators.success(
        topicResponse,
        contentResponse,
        sidebarResponse,
        userDataResponse,
        Array.isArray(tagsResponse) ? {} : tagsResponse
      )
    )

    state = yield select()
    let langurl
    lang === "de"
      ? (langurl = state.router.route.replace("/:lang/", "/en/"))
      : (langurl = state.router.route.replace("/:lang/", "/de/"))
    yield put(LangCreators.success(langurl))

    // tracking
    yield put(
      AppCreators.trackingAdd({
        event: "mtm.virtualPageView",
        section: "learning",
        page_type: "topics",
        document_title: i18n.t("Akademie")
      })
    )
  } catch (e) {
    yield put(Creators.error(readableErrors(e)))
  }
}



// WEBPACK FOOTER //
// ./src/containers/Learning/sagas.js